import { render, staticRenderFns } from "./TableMenu.vue?vue&type=template&id=3f4d24ff&scoped=true"
import script from "./TableMenu.vue?vue&type=script&lang=js"
export * from "./TableMenu.vue?vue&type=script&lang=js"
import style0 from "./TableMenu.vue?vue&type=style&index=0&id=3f4d24ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d24ff",
  null
  
)

export default component.exports